<div class="modal-header">
  <span class="modal-title">{{title}}</span>
  <button type="button" class="btn-close " aria-label="Close" (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
<div class="settings-container flex flex-column">
      <div class="no-results" *ngIf="empty">
        No airport contacts found
      </div>
    <div class="item-list" *ngFor="let item of data | keyvalue">
      <app-settings-list
        [opened]="selected === item?.key"
        [noEditDeleteBar]="readonly"
        (editClicked)="doEdit(item?.key)"
        (deleteClicked)="doDelete(item?.key)">

        <app-manage-airport-contact-dialog-list-item
          [opened]="selected === item?.key"
          [item]="item.value"
          [shallNotOpen]="readonly"
          (click)="selected = item?.key">
        </app-manage-airport-contact-dialog-list-item>

      </app-settings-list>
    </div>
  <app-add-row *ngIf="!readonly" (addClicked)="doAdd()"></app-add-row>
</div>
</div>
